import { ActionFunctionArgs, redirect } from "react-router-dom";
import { ManageCourseUpdateSectionDTO } from "../types/manageCourseActionTypes";
import { apiEndpoints } from "@/services/api/api";
export async function ManageCourseUpdateSectionAction({
  request,
  params,
}: ActionFunctionArgs) {
  const formData = await request.formData();
  const sectionId = params.sectionId;
  const courseId = params.courseId;
  if (!sectionId || !courseId) {
    throw new Error("Section and course id is required");
  }
  const name = formData.get("name") as string;
  if (!name) {
    throw new Error("Section name is required");
  }
  const enhancedData: ManageCourseUpdateSectionDTO = {
    id: sectionId,
    name: name,
  };
  try {
    const response = await apiEndpoints.lecturerUpdateSection(enhancedData);
    if (!response.success) {
      throw new Error("Failed to update section");
    }
    return redirect(`/lecturer/manage-course/${courseId}`);
  } catch (error) {
    console.error("Error updating section:", error);
    throw new Error("Failed to update section");
  }
}
